/* eslint-disable */
import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'

import * as Yup from 'yup'
import {useFormik} from 'formik'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {officialExpenseUpdate} from '../../../redux/slices/official.slice'
import {InputPrice, Datepicker} from '../../'

const OfficialModal = ({onOpen, onClose, error, data}) => {
  const [show, setShow] = useState(onOpen)
  const intl = useIntl()

  useEffect(() => {
    setShow(onOpen)
  }, [onOpen])

  const handleClose = () => {
    setShow(false)
    onClose && onClose()
  }

  useEffect(() => {
    if (error && show) {
      setShow(false)
    }
  }, [error])

  const dispatch = useDispatch()

  const validSchema = Yup.object().shape({
    TotalPrice: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    TotalTax: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    TotalWithHolding: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    InvoiceDate: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
  })

  const [formValues] = useState({
    Id: 0,
    Name: '',
    InvoiceNumber: '',
    TotalPrice: 0,
    TotalTax: 0,
    TotalWithHolding: 0,
    InvoiceDate: new Date(),
  })

  const formik = useFormik({
    initialValues: formValues,
    validationSchema: validSchema,
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true)
      dispatch(officialExpenseUpdate(values))
      resetForm()
      setShow(false)
      onClose && onClose()
    },
  })

  useEffect(() => {
    if (data) {
      formik.setFieldValue('Id', data?.id)
      formik.setFieldValue('Name', data?.name)
      formik.setFieldValue('InvoiceNumber', data?.invoiceNumber)
      formik.setFieldValue('InvoiceDate', data?.invoiceDate)
      formik.setFieldValue('TotalPrice', data?.totalPrice)
      formik.setFieldValue('TotalTax', data?.totalTax)
      formik.setFieldValue('TotalWithHolding', data?.totalWithHolding)
    }
  }, [data])

  return (
    <>
      <Modal
        className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
        id='kt_inbox_compose'
        role='dialog'
        data-backdrop='false'
        aria-hidden='true'
        tabIndex='-1'
        show={show}
        animation={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        onHide={handleClose}
      >
        <div className='modal-content'>
          <form className='form position-relative' onSubmit={formik.handleSubmit} noValidate>
            <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
              <h5 className='fw-bold m-0'>
                {intl.formatMessage({id: 'SALEINVOICE.CREATE.OFFICIAL'})}
              </h5>
              <div className='d-flex ms-2'>
                <div
                  className='btn btn-icon btn-sm btn-light-primary ms-2'
                  data-bs-dismiss='modal'
                  onClick={handleClose}
                >
                  <KTSVG className='svg-icon-1' path='/images/icons/duotune/arrows/arr061.svg' />
                </div>
              </div>
            </div>

            <div className='d-block py-5 ps-8 pe-5'>
              <div className='row mb-6'>
                <label className='col-lg-12 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'OFFICIALEXPENSE.CREATE.NAME'})}
                </label>
                <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                  <input
                    type='text'
                    className='form-control form-control-solid mb-3 mb-lg-0'
                    autoComplete='off'
                    required
                    disabled={formik.isSubmitting}
                    {...formik.getFieldProps('Name')}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-12 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'OFFICIALEXPENSE.CREATE.INVOICENUMBER'})}
                </label>
                <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                  <input
                    type='text'
                    className='form-control form-control-solid mb-3 mb-lg-0'
                    autoComplete='off'
                    required
                    disabled={formik.isSubmitting}
                    {...formik.getFieldProps('InvoiceNumber')}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-12 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'OFFICIALEXPENSE.CREATE.INVOICEDATE'})}
                </label>
                <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                  <Datepicker
                    {...formik.getFieldProps('InvoiceDate')}
                    onChange={([date]) => formik.setFieldValue('InvoiceDate', date)}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-12 required fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'OFFICIALEXPENSE.CREATE.TOTALPRICE'})}
                </label>
                <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                  <InputPrice
                    {...formik.getFieldProps('TotalPrice')}
                    onChange={(value) => formik.setFieldValue('TotalPrice', Number(value))}
                  />
                  {formik.touched.TotalPrice && formik.errors.TotalPrice && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.TotalPrice}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-12 required fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'OFFICIALEXPENSE.CREATE.TOTALTAX'})}
                </label>
                <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                  <InputPrice
                    {...formik.getFieldProps('TotalTax')}
                    onChange={(value) => formik.setFieldValue('TotalTax', Number(value))}
                  />
                  {formik.touched.TotalTax && formik.errors.TotalTax && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.TotalTax}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-12 required fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'OFFICIALEXPENSE.CREATE.TOTALWITHHOLDING'})}
                </label>
                <div className='col-lg-12 fv-row fv-plugins-icon-container'>
                  <InputPrice
                    {...formik.getFieldProps('TotalWithHolding')}
                    onChange={(value) => formik.setFieldValue('TotalWithHolding', Number(value))}
                  />
                  {formik.touched.TotalWithHolding && formik.errors.TotalWithHolding && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.TotalWithHolding}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='d-flex align-items-center justify-content-center py-5 ps-8 pe-5 border-top'>
              <div className='d-flex align-items-center me-3'>
                <button className='btn btn-light me-3' onClick={handleClose}>
                  {intl.formatMessage({id: 'BUTTON.CLOSE'})}
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  {intl.formatMessage({id: 'BUTTON.SUBMIT'})}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

OfficialModal.propTypes = {
  onOpen: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
}

OfficialModal.defaultProps = {
  onOpen: false,
}

export {OfficialModal}
